module.exports = __webpack_public_path__ + "static/media/deck-3-super.c1c9a1ce.png";